<script>
import { mapGetters } from 'vuex'
export default {

    name: 'thank-you',

    computed:
    {
        ...mapGetters({
            visitor: 'visitor',
            channel: 'channel',
        }),

        user()
        {
            return this.visitor.subscription || {}
        },

        signed()
        {
            const arr = []
            if (this.user.offer_signups)
            {
                for (let i = 0; i < this.user.offer_signups.length; ++i)
                {
                    const item = this.user.offer_signups[i]
                    if (item.activated)
                        arr.push(item)
                }
            }
            return arr
        }
    },

    methods:
    {

    },

    mounted()
    {
        const redirect = window.localStorage.getItem('loverly_redirect')
        if (redirect)
        {
            window.location = redirect
            return
        }
    }

}
</script>

<template lang="html">
  <div class="white-bgc">
      <div class="offer-head text-center">
          <div class="container-fluid cont-720">
              <logo></logo>
          </div>
      </div>

      <div class="container-fluid cont-720">
          <div class="offer-done-message" v-if="(channel && channel.thank_you_header) || signed.length > 0">

              <p class="smaller" v-if="channel && channel.thank_you_header">
                  {{ channel.thank_you_header }}
              </p>

              <template v-if="signed.length > 0">
                <p>
                    You have also subscribed to
                </p>

                <ul>
                    <li v-for="offer in signed" :key="offer.id">{{ offer.offer.name }}</li>
                </ul>
              </template>
          </div>

          <div class="offer-body" v-if="channel.instagram_tag && channel.instagram_id && channel.instagram_token">

              <div class="loverly-insta-feed text-center">
                  <div class="loverly-insta-feed-title">
                      <logo></logo>
                      <strong class="text-uppercase">on</strong>
                      <span class="instagram-text-logo"></span>
                  </div>
                  <div class="loverly-insta-feed-content">
                      <insta-feed class="row"></insta-feed>
                  </div>
                  <div class="loverly-insta-feed-footer">
                      <a class="btn btn-instagram" :href="'http://instagram.com/' + channel.instagram_tag" target="_blank">
                          Follow @{{ channel.instagram_tag }}
                      </a>
                      <span class="d-none d-sm-inline">
                          on Instagram for daily dose of inspiration
                      </span>
                  </div>
              </div>

          </div>

          <p class="offer-done-continue text-center" v-if="channel.thank_you_link">
              <a :href="channel.thank_you_link">
                  {{ channel.thank_you_link_name }}
                  <i class="fal fa-long-arrow-right"></i>
              </a>
          </p>
      </div>

  </div>
</template>



// WEBPACK FOOTER //
// src/components/thankyous/ThankYou.vue